<template>
  <div id="app">
    <Navigation />
    <router-view />
  </div>
</template>

<style lang="scss">
@import "src/assets/styles.scss";
@import "node_modules/bootstrap/scss/bootstrap.scss";
</style>

<script>
import store from "./store";
import Navigation from "@/components/Navigation.vue";
import Firebase from "firebase";
import db from "./db.js";

export default {
  store,
  name: "App",
  data: function() {
    return {
      user: null,
      srcVidIDs: store.state.srcVidIDs,
      videos: store.state.videos,
      srcVideos: store.state.srcVideos,
    };
  },
  methods: {
    addVideo: function(payload) {
      db.collection("videos").add({
        videoTitle: payload,
        headshot: "",
        introBlurb: "",
        outroCTA: "",
        outroPhone: "",
        outroEmail: "",
        createdAt: Firebase.firestore.FieldValue.serverTimestamp(),
        userID: this.user.uid,
        srcVid: this.srcVid,
      });
    },
    deleteVideo: function(payload) {
      db.collection("videos")
        .doc(payload.id)
        .delete();
    },
  },
  created() {
    this.$root.$refs.App = this;
  },
  mounted() {
    Firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        for (var i = 0; i < this.srcVidIDs.length; i++) {
          let srcVid = this.srcVidIDs[i];
          this.user = user;
          this.$store.commit("setUser", user);

          // db.collection("videos")
          // //.where("userID", "==", "P9JXTax7DZRY1MYm21aqMez9J5x1")
          // .where("render-status", "==", "ready")
          // .onSnapshot(function(querySnapshot) {
          //   var videos = [];
          //   querySnapshot.forEach(function(doc) {
          //     videos.push(JSON.stringify(doc.data()));
          //   });
          //get videos from firebase where the userID matches the logged in user
          db.collection("videos")
            .where("userID", "==", this.user.uid)
            .orderBy("createdAt")
            .onSnapshot((snapshot) => {
              const snapData = [];
              snapshot.forEach((doc) => {
                snapData.push({
                  id: doc.id,
                  videoTitle: doc.data().videoTitle,
                  headshot: doc.data().headshot,
                  introBlurb: doc.data().introBlurb,
                  outroCTA: doc.data().outroCTA,
                  outroPhone: doc.data().outroPhone,
                  outroEmail: doc.data().outroEmail,
                  name: doc.data().name,
                  title: doc.data().title,
                  "render-status": doc.data()["render-status"],
                  customVideo: doc.data().customVideo,
                  createdAt: doc.data().createdAt,
                  srcVid: srcVid,
                });
              });
              //firebase always returns in ascending order
              this.videos[srcVid] = snapData.reverse();
            });
          console.log(
            this.user.uid + " : " + JSON.stringify(this.videos[srcVid])
          );
        }
      } else {
        this.user = null;
      }
    });
  },
  components: {
    Navigation,
  },
};
</script>
